import { environment } from '../../../../../environments/environment';
import { StorageManager } from '../../../../common/storage-manager.class';

export class TareasPlantacionEnvironmentDefinition {
    public readonly appName = environment.appName;
    public readonly serverUrl = environment.serverUrl;
    public readonly fincaName = environment.features.fincaName;
    public readonly hasClients = environment.features.hasClients;
    public readonly clienteName = environment.features.clienteName;
    public readonly showTareasMto = environment.features.showTareasMto;
    public readonly userCanSeeClientes = environment.features.userCanSeeClientes;
    public readonly canSeeClientes = this.hasClients && (
        this.userCanSeeClientes ? true : StorageManager.getUser().rol === 'admin'
    );
}
